/* ==================================================================
   Aenderung 22.10.2026 (Ben) - Rechtsvorgabe Cookie-Banner
   ------------------------------------------------------------------
   Das Newsletter-Popup ging nach 20 Sekunden von selbst auf, auch
   wenn das Cookie-Banner noch offen war. Gemessen am 22.10.2026
   (375x812, frischer Zustand): Das Popup stand mit data-hidden="false"
   offen hinter dem Banner (Banner z-index 2000000, Popup 502) und
   setzte den Eingabefokus ins E-Mail-Feld, waehrend die Einwilligung
   noch abgefragt wurde.

   Geaendert ist nur das AUTOMATISCHE Oeffnen (siehe sbAutoOeffnenErlaubt
   und die Stelle im setTimeout weiter unten):
   - Am Handy geht das Popup gar nicht mehr von selbst auf.
   - Am Rechner erst, wenn die Cookie-Entscheidung gefallen ist.
   Der Knopf "10 % mit Newsletter" oeffnet es unveraendert auf Klick -
   das ist eine bewusste Handlung der Besucherin und bleibt erlaubt.
   ================================================================== */

/* Darf sich das Popup von selbst oeffnen? */
function sbAutoOeffnenErlaubt(){
    // Am Handy nie von selbst oeffnen: Der Platz reicht dort nicht fuer
    // Banner und Popup nebeneinander.
    try {
        if(window.matchMedia('(max-width: 48rem)').matches) return false;
    } catch(e) {}

    // Steht das Cookie-Banner im Bild, hat es Vorrang.
    var banner = document.querySelector('#shopify-pc__banner');
    if(banner){
        var cs = window.getComputedStyle(banner);
        if(cs.display !== 'none' && cs.visibility !== 'hidden' && banner.getBoundingClientRect().height > 0) return false;
    }

    /* Ist die Entscheidung schon gefallen? Solange alle Werte leer sind,
       ist noch nicht entschieden. shouldShowBanner() taugt dafuer NICHT -
       es liefert auch danach weiter true (am 21.10.2026 gemessen). */
    try {
        var cp = window.Shopify && window.Shopify.customerPrivacy;
        if(cp && typeof cp.currentVisitorConsent === 'function'){
            var c = cp.currentVisitorConsent() || {};
            var felder = ['analytics', 'marketing', 'preferences'];
            for(var i = 0; i < felder.length; i++){
                if(c[felder[i]] === 'yes' || c[felder[i]] === 'no') return true;
            }
            return false;
        }
    } catch(e) { /* API noch nicht bereit */ }

    return true;
}

if(!customElements.get('newsletter-popup')){
    class NewsletterPopup extends HTMLElement {
        constructor(){
            super();
        }

        connectedCallback(){
            this.form = this.querySelector('.newsletter-form');
            this.buttonSubmit = this.querySelector('input[type="submit"]');

            // close popup
            this.querySelectorAll('[data-close]').forEach(item => {
                item.addEventListener('click', this.closePopup.bind(this));
                item.addEventListener('keydown', e => {
                    if(e.key === 'Enter' || e.key === ' '){
                        e.preventDefault();
                        this.closePopup();
                    }
                });
            });
            this.addEventListener('click', e => {
                if(e.target === this) this.closePopup();
            });
            this.addEventListener('keyup', e => {
                if(e.code && e.code.toUpperCase() === 'ESCAPE') this.closePopup();
            });

            // submit
            this.form.addEventListener('submit', this.submitForm.bind(this));

            // adjust top margin
            if(this.dataset.verticalPosition === 'top'){
                this.adjustTopPosition();
                window.addEventListener('scroll', () => {
                    this.adjustTopPosition();
                });
            }

            // open popup
            if(window.location.pathname == '/challenge'){
                this.delay = 10;
            }
            this.delay = this.delay? this.delay : parseInt(this.dataset.delay);
            this.popupClosed = getCookie('newsletter-closed');

            setTimeout(() => {
                if(this.popupClosed !== null) return;
                if(sessionStorage.getItem('newsletter-popup-open') == 'true') return; // display once per session
                // Snackberries 22.10.2026: nicht ueber das Cookie-Banner legen,
                // am Handy gar nicht von selbst oeffnen (Erklaerung ganz oben).
                if(!sbAutoOeffnenErlaubt()) return;
                this.openPopup();
            }, this.delay);

            // open newsletter popup by clicking button
            document.querySelectorAll('.button-newsletter').forEach(item => {
                const action = item.dataset.action;
                const object = item.dataset.object;

                if(action == 'open' && object == 'newsletter-popup'){
                    item.addEventListener('click', (e) => {
                        this.openPopup(e, item);
                    });

                    if(getCookie('newsletter-button-closed') !== 'true'){
                        item.setAttribute('data-hidden', 'false');
                        item.removeAttribute('inert');
                    }
                }
            });
        }

        adjustTopPosition(){
            const header = document.querySelector('custom-header');
            const utilityBar = document.querySelector('custom-utility-bar');

            if(header){
                var topPosition = 0;
                
                const topScroll = utilityBar? utilityBar.clientHeight : 0;
                const currentScroll = window.scrollY;

                const sticky = header.dataset.sticky;
                const scroll = header.dataset.scroll;
                const scrollTop = header.dataset.scrollTop;

                if(sticky == 'scroll-up' && scroll == 'false' && scrollTop == 'false'){
                }else if(sticky == 'none' && scroll == 'true'){
                }else{
                    topPosition = header.offsetHeight;

                    if(scroll !== 'true' && utilityBar){
                        topPosition += utilityBar.offsetHeight;
                    }

                    if(sticky == 'none' && currentScroll > topScroll){
                        topPosition = 0;
                    }
                }

                this.style.top = `${topPosition}px`;
            }
        }

        openPopup(e = null, triggerElement = null) {
            if(e !== null){
                e.preventDefault();

                const currentElem = e.target;
                let buttonClose;
                if(currentElem.classList.contains('button-close')){
                    buttonClose = currentElem.classList.contains('button-close');
                }else if(currentElem.closest('.button-close')){
                    buttonClose = currentElem.closest(".button-close");
                }

                if(buttonClose){
                    const buttonNewsletter = buttonClose.closest('.button-newsletter');

                    buttonNewsletter.setAttribute('data-hidden', 'true');
                    buttonNewsletter.setAttribute('inert', '');
                    setCookie('newsletter-button-closed', 'true');
                    return;
                }
            }

            this.previouslyFocusedElement = triggerElement || document.activeElement;

            this.setAttribute('data-hidden', 'false');
            this.removeAttribute('inert');
            sessionStorage.setItem('newsletter-popup-open', 'true');

            this.addFocus();

            document.querySelectorAll('.button-newsletter').forEach(item => {
                const action = item.dataset.action;
                const object = item.dataset.object;

                if(action == 'open' && object == 'newsletter-popup'){
                    item.setAttribute('data-hidden', 'true');
                    item.setAttribute("inert", '');
                }
            });
        }

        addFocus(){
            if(this.form){
                setTimeout(() => {
                    this.form.querySelector('.input-email')?.focus();
                }, 100);
            }
        }

        closePopup(){
            this.setAttribute('data-hidden', 'true');
            this.setAttribute('inert', '');
            setCookie('newsletter-closed', 'true');

            document.querySelectorAll('.button-newsletter').forEach(item => {
                const action = item.dataset.action;
                const object = item.dataset.object;

                if(action == 'open' && object == 'newsletter-popup'){
                    item.setAttribute('data-hidden', 'false');
                    item.removeAttribute('inert');
                }
            });

            if(this.previouslyFocusedElement){
                this.previouslyFocusedElement.focus();
            }
        }

        submitForm(e){
            if(window.Shopify.recaptchaV3) return;
            if(this.buttonSubmit.getAttribute('disabled') == 'disabled') return;

            this.buttonSubmit.setAttribute('disabled', 'disabled');
        }
    }

    customElements.define('newsletter-popup', NewsletterPopup);
}